export const getLocation = (): Location | undefined =>
	// oxlint-disable-next-line no-restricted-globals -- This helper reads the host location global directly.
	typeof location === 'undefined' ? undefined : location;
